export enum ChargebeeCheckoutStep {
  THANKYOU_SCREEN = 'thankyou_screen',
}
